/** A GM status UUID is provenance only; it never names a second definition payload.
 * Callers supply their existing readers' scalar values (including lean omissions).
 */
export function isSelfStatusOrigin(statusId: unknown, originId: unknown): boolean {
  return typeof statusId === 'string' && statusId !== '' && statusId === originId;
}
